<div class="filter-container">
    <div class="filter-close">
        <button class="filter-close-btn" (click)="close()">x</button>
    </div>
    <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="mb-0 fw-bolder fw-">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.9 7C12.5 5.3 10.9 4 9 4C7.1 4 5.6 5.3 5.1 7H2V9H5.1C5.5 10.7 7.1 12 9 12C10.9 12 12.4 10.7 12.9 9H30V7H12.9ZM9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10ZM23 12C21.1 12 19.6 13.3 19.1 15H2V17H19.1C19.5 18.7 21.1 20 23 20C24.9 20 26.4 18.7 26.9 17H30V15H26.9C26.5 13.3 24.9 12 23 12ZM23 18C21.9 18 21 17.1 21 16C21 14.9 21.9 14 23 14C24.1 14 25 14.9 25 16C25 17.1 24.1 18 23 18ZM14 20C12.1 20 10.6 21.3 10.1 23H2V25H10.1C10.5 26.7 12.1 28 14 28C15.9 28 17.4 26.7 17.9 25H30V23H17.9C17.5 21.3 15.9 20 14 20ZM14 26C12.9 26 12 25.1 12 24C12 22.9 12.9 22 14 22C15.1 22 16 22.9 16 24C16 25.1 15.1 26 14 26Z" fill="#718998"/>
            </svg>
            Filters
        </h4>
    </div>

    <hr />

    <form [formGroup]="form" (submit)="applyFilter()">
        <!-- Caseload scope -->
        <div class="mb-3">
            <small class="text-muted fw-semibold">Caseload scope</small>

            <div class="form-check mt-2">
                <input
                    class="form-check-input"
                    type="radio"
                    value="all"
                    formControlName="scope"
                    id="allPatients"
                />
                <label class="form-check-label" for="allPatients">
                    All patients
                </label>
            </div>

            <div class="form-check">
                <input
                    class="form-check-input"
                    type="radio"
                    value="active"
                    formControlName="scope"
                    id="myPatients"
                />
                <label class="form-check-label" for="myPatients">
                    My patients
                </label>
            </div>
        </div>

        <hr />

        <!-- MEED Risk status -->
        <div class="mb-3" formGroupName="meedRiskStatus">
            <small class="text-muted fw-semibold">Risk status</small>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="High" id="highRisk" />
                <label class="form-check-label" for="highRisk">High risk</label>
            </div>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="Moderate" id="moderateRisk" />
                <label class="form-check-label" for="moderateRisk">Moderate risk</label>
            </div>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="Low" id="lowRisk" />
                <label class="form-check-label" for="lowRisk">Low risk</label>
            </div>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="Unknown" id="unknownRisk" />
                <label class="form-check-label" for="unknownRisk">Unknown</label>
            </div>
        </div>

        <hr />

        <!-- Adherence -->
        <div class="mb-3" formGroupName="adherence">
            <small class="text-muted fw-semibold">Adherence</small>

            <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" formControlName="low" id="adherenceLow" />
                <label class="form-check-label" for="adherenceLow">
                    Low adherence (&lt;50%)
                </label>
            </div>

            <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" formControlName="medium" id="adherenceMedium" />
                <label class="form-check-label" for="adherenceMedium">
                    Medium adherence
                </label>
            </div>

            <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" formControlName="high" id="adherenceHigh" />
                <label class="form-check-label" for="adherenceHigh">
                    High adherence
                </label>
            </div>

            <small class="text-muted d-block mt-1">
                Based on last 7 days of check-ins
            </small>
        </div>

        <hr />

        <!-- Programme stage -->
        <div class="mb-3" formGroupName="programStage">
            <small class="text-muted fw-semibold">Programme stage</small>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="early" id="earlyStage" />
                <label class="form-check-label" for="earlyStage">Early stage</label>
            </div>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="mid" id="midStage" />
                <label class="form-check-label" for="midStage">Mid stage</label>
            </div>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="late" id="lateStage" />
                <label class="form-check-label" for="lateStage">Late stage</label>
            </div>
        </div>

        <hr />

        <!-- Trend -->
        <div class="mb-4" formGroupName="promsTrend">
            <small class="text-muted fw-semibold">Trend</small>

            <div class="form-check mt-2">
                <input class="form-check-input" type="checkbox" formControlName="improving" id="improving" />
                <label class="form-check-label" for="improving">
                    Improving <i class="bi bi-arrow-up"></i>
                </label>
            </div>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="stable" id="stable" />
                <label class="form-check-label" for="stable">
                    Stable <i class="bi bi-arrow-right"></i>
                </label>
            </div>

            <div class="form-check">
                <input class="form-check-input" type="checkbox" formControlName="deteriorating" id="deteriorating" />
                <label class="form-check-label" for="deteriorating">
                    Deteriorating <i class="bi bi-arrow-down"></i>
                </label>
            </div>
        </div>

        <!-- Buttons -->
        <div class="d-grid gap-2 mt-2">
            <button type="button" class="btn btn-outline-secondary rounded-pill fw-bold" (click)="reset()">
                RESET ALL
            </button>
            <button type="submit" class="btn btn-success rounded-pill fw-bold">
                APPLY FILTERS
            </button>
        </div>
    </form>
</div>
